($ => {
	// $('.table-of-contents-action.action-contents').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').addClass('no-scroll');
	// 	$('#table-of-contents').fadeIn();
	// });
	// $('.table-of-contents__background, .table-of-contents__close').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').removeClass('no-scroll');
	// 	$('#table-of-contents').fadeOut();
	// 	$('#excerpt').fadeOut();
	// });

	// $('.table-of-contents-action.action-excerpt').click(e => {
	// 	e.preventDefault();
	// 	$('body, html').addClass('no-scroll');
	// 	$('#excerpt').fadeIn();
	// });
})(jQuery)